import React from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'
import { hideReduxModal } from '../../../Reducers/UI/actions'
import GenericFlatButton from '../../GenericFlatButton'

import { styles } from './styles'

const DeleteDocModalBody = ({ onConfirm, classes }) => {
  const dispatch = useDispatch()

  return (
    <div className={classes.modalContainer}>
      <div className={classes.modalTitle}>Are you sure?</div>
      <div className={classes.description}>
        This action will remove the file from completely, it will never be
        accessible again
      </div>

      <div className={classes.modalButtonContainer}>
        <GenericFlatButton
          type={'outline'}
          title={'Cancel'}
          onClick={() => {
            dispatch(hideReduxModal())
          }}
        />
        <GenericFlatButton
          type={'filled'}
          title={'Confirm'}
          onClick={async () => {
            await onConfirm()
            dispatch(hideReduxModal())
          }}
        />
      </div>
    </div>
  )
}

export default injectStyles(styles)(DeleteDocModalBody)
